"use client";

import { useState } from "react";
import { CalendarDays, FilterX } from "lucide-react";
import { Button, EmptyState, FilterChip, FilterChipGroup } from "@nitro/ui";
import { matchesCompetitionFilter } from "../lib/competitionFilters";
import styles from "./SimulatorCompetitionList.module.css";

export function SimulatorCompetitionList({ entries = [], simulatorName }) {
  const [filter, setFilter] = useState("all");
  const visible = entries.filter((entry) => matchesCompetitionFilter(entry, filter));
  const filters = [
    ["all", "Todas"], ["open", "Inscripción abierta"], ["events", "Eventos"], ["championships", "Campeonatos"],
  ];
  return (
    <div className="simulator-hub-panel" id="competencias">
      <div className="simulator-hub-panel-head">
        <div><p className="nitro-eyebrow">Competencias</p><h2>Eventos y campeonatos</h2><p>{simulatorName}: consulta los eventos y campeonatos publicados.</p></div>
        <FilterChipGroup className={styles.filters} label="Filtrar competencias" value={filter} onValueChange={setFilter}>
          {filters.map(([value, label]) => <FilterChip key={value} value={value} count={entries.filter((entry) => matchesCompetitionFilter(entry, value)).length}>{label}</FilterChip>)}
        </FilterChipGroup>
      </div>
      <p className={styles.count} aria-live="polite">{visible.length} {visible.length === 1 ? "competencia" : "competencias"}</p>
      <div className="simulator-event-list">
        {visible.length ? visible.map((entry) => <div key={entry.slug}>{entry.content}</div>) : entries.length ? (
          <EmptyState title="No hay competencias con este filtro" description="Prueba otra selección para ver las competencias disponibles." action={<Button iconStart={<FilterX size={16} />} variant="secondary" onClick={() => setFilter("all")}>Mostrar todas</Button>} />
        ) : (
          <EmptyState title="No hay competencias publicadas" description={`Las próximas competencias de ${simulatorName} aparecerán aquí cuando estén publicadas.`} action={<Button as="a" href="/eventos" iconStart={<CalendarDays size={16} />} variant="secondary">Ver todos los eventos</Button>} />
        )}
      </div>
    </div>
  );
}
